import { render, staticRenderFns } from "./WeightSelect.vue?vue&type=template&id=9e26d3d0"
import script from "./WeightSelect.vue?vue&type=script&lang=js"
export * from "./WeightSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports